import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Skill } from '../types/skill.types';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SkillService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  public searchSkills(searchString: string) {
    return this.http.get<Skill[]>(
      environment.apiUrl + '/skills/?search_str=' + searchString + '&lang=' + this.translateService.getCurrentLang()
    );
  }

  public getAllSkills() {
    return this.http.get<Skill[]>(environment.apiUrl + '/skills/');
  }
}
